import { Injectable }   from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Injectable()
export class EstruturaFamiliarService {

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Estrutura Familiar por id
     * @param id ID da Estrutura Familiar 
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "patrimonial/estrutura-familiar/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Estrutura Familiar 
     * @param id ID da Estrutura Familiar 
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "patrimonial/estrutura-familiar"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete de Estrutura Familiar 
     * @param id ID da Estrutura Familiar 
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "patrimonial/estrutura-familiar/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Estrutura Familiar 
     * @param params Json Estrutura Familiar 
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "patrimonial/estrutura-familiar", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Estrutura Familiar 
     * @param params Json Estrutura Familiar 
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "patrimonial/estrutura-familiar/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Exporta Lista em Excel
     * @param id ID
     */
    getAllExport(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";

        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }
        return this._http.get(this.utilitesService.urlPrefix + "patrimonial/estrutura-familiar/export" + env, {
            responseType: "arraybuffer",
            headers: new HttpHeaders({
                "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8",
                "Authorization": "Bearer " + this.authService.getToken(),
                "Access-Control-Allow-Origin": "*"
            })
        });
    }

}
